import * as React from 'react';
import styled from 'styled-components';
import { NavOption, ActionOptions } from '../../types';
import Actions from '../Actions';
import ExitMenuButton from './ExitMenuButton';
import { Menu, Right, MenuSection, MenuSectionList, MenuLink, RowLayout } from './CommonStyles';

const FirstRowLayout = styled(RowLayout)`
  margin-top: 5px;
`;

type Props = {
  name: string;
  mainNavLabel?: string;
  navigationOptions?: NavOption[];
  actions?: ActionOptions;
  clickMenuAction: () => void;
  firstName?: string;
  lastName?: string;
  actionList?: ActionOptions;
};

const MobileActionMenu = ({ clickMenuAction, navigationOptions, firstName, lastName, actionList }: Props) => {
  return (
    <Menu role="menu" aria-labelledby="UserMenuButton">
      <FirstRowLayout>
        <>
          <Actions actions={actionList} firstName={firstName} lastName={lastName} isInMobileMenu={true} useUserMenu={false} setShowUserMenu={() => {}} />
        </>
        <Right>
          <ExitMenuButton closeMenu={clickMenuAction} />
        </Right>
      </FirstRowLayout>
      <MenuSection>
        <MenuSectionList>
          {navigationOptions?.map(no => (
            <li key={no.label} onClick={() => clickMenuAction()}>
              <MenuLink to={no.to} role="menuitem">
                <div>{no.label}</div>
              </MenuLink>
            </li>
          ))}
        </MenuSectionList>
      </MenuSection>
    </Menu>
  );
};

export default MobileActionMenu;
